// Renamed from LandingPageEmotional.js
import React from 'react';
import LandingPageEmotional from './LandingPageEmotional';

const SleepPeace = () => {
  return <LandingPageEmotional />;
};

export default SleepPeace;
